import { useEffect, useState } from "react";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";

// §77 Shown to client-scoped users: they only see results from their own workflows / projects.
export const ScopeNote = ({ url, what, testid }) => {
  const [scope, setScope] = useState(null);
  useEffect(() => { api.get(url).then((r) => setScope(r.data?.scope || null)).catch(() => setScope(null)); }, [url]);
  if (scope !== "own") return null;
  return <p className="flex items-center gap-1.5 rounded-xl border border-[#8224e3]/30 bg-[#8224e3]/10 px-3 py-2 text-xs text-[#d7b6ff]" data-testid={testid}><Lock className="h-3.5 w-3.5" />You're seeing {what} only. Other people's results are private to them.</p>;
};
